module.exports = __webpack_public_path__ + "3692f35f78a81ca903f1c3ea5ede00e2.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/ic_delete_black_24px.svg
// module id = /vpW
// module chunks = 1